import { defineMessages } from "react-intl";

export default defineMessages({
  done: {
    id: "app.components.Associator.done",
    defaultMessage: "Done"
  }
});
